.cr{z-index:2;}